module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAIAAABwJOjsAAAAdklEQVRIx2NgmHR8YNCoxaMW0wwFJk4dEMTwisWcNMRu+TGk/MeavZ+ia1+LuZCsHYZItvhr85yfe069FgVZ+VbO+420J10s5rD6++z1B49cCPdTZsffxy+A5DC2eMCCmoqJS2ZK+YAgBoZ1GQODRi0etZhWCABHQtF+Icj6swAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/az.png
// module id = 775
// module chunks = 0